import React from 'react';
import { Modal } from '@gerdau/hefesto/';

type ModalButton = {
  title: string;
  onClick: () => void;
  canShow?: boolean;
};

export const ErrorModal = ({
  show,
  title,
  description,
  modalSize = 'sm',
  buttonRight,
  buttonLeft
}: {
  show: boolean;
  title: string;
  description: string;
  modalSize?: 'sm' | 'md' | 'lg';
  buttonRight: ModalButton;
  buttonLeft: ModalButton;
}) => {
  if (!show) {
    return null;
  }

  return (
    <Modal
      buttons={{
        right: {
          children: buttonRight.title,
          name: 'detele',
          type: 'button',
          variant: 'primary',
          onClick: buttonRight.onClick
        },
        ...(buttonLeft.canShow && {
          left: {
            children: buttonLeft.title,
            name: 'cancel',
            type: 'button',
            variant: 'secondary',
            onClick: buttonLeft.onClick
          }
        })
      }}
      modalSize={modalSize}
      title={title}
    >
      <p>{description}</p>
    </Modal>
  );
};
